import { RadioButton } from "@newsela/angelou";
import { actionNames, objectTypes, withTrackEvent } from "@newsela/snitch";

import { useSearchPageContext } from "@/search/Langston/SearchPageProvider";
import { IContentValues } from "@/search/Langston/types/IContentValues";
import { useSearchAdminPermissions } from "@/search/Langston/useSearchAdminPermissions";
import { optionsCss } from "./RadioFilter.styles";

const RadioButtonWithTrackEvent = withTrackEvent(RadioButton);

export const RadioFilter = ({ options, paramName }: IRadioFilter) => {
  const {
    getters: { isDisabledFilters },
    handlers: { hasSearchParamValue, setSearchParamValue },
  } = useSearchPageContext();
  const { blockActionAndShowConfirmationModal, blockFilterChanges } =
    useSearchAdminPermissions();

  const onChange = (option: IContentValues) => {
    if (blockFilterChanges) {
      blockActionAndShowConfirmationModal();
      return;
    }
    setSearchParamValue(paramName, option.value);
  };

  return (
    <>
      {!!options?.length && (
        <div css={optionsCss}>
          {options.map((option) => {
            return (
              <RadioButtonWithTrackEvent
                key={option.value}
                value={option.value}
                label={option.label}
                name={option.label}
                checked={hasSearchParamValue(paramName, option.value)}
                disabled={isDisabledFilters}
                onChange={() => onChange(option)}
                dataProps={{
                  "data-qa-selector": `${option.value}-${paramName}-filter-option`,
                }}
                objectType={objectTypes.content}
                actionName={actionNames.filter}
              />
            );
          })}
        </div>
      )}
    </>
  );
};

interface IRadioFilter {
  paramName: string;
  options: IContentValues[];
}
